import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/board/excel_ico.png'


const _hoisted_1 = { class: "layer" }
const _hoisted_2 = { class: "wrap" }
const _hoisted_3 = { class: "content_layer" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { id: "board_layer" }
const _hoisted_6 = { class: "board_top" }
const _hoisted_7 = { class: "board_top_btns" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "엑셀다운로드", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { class: "board_top_btns_right" }
const _hoisted_12 = { class: "count" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("option", { value: "20" }, "20", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("option", { value: "50" }, "50", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("option", { value: "70" }, "70", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("option", { value: "100" }, "100", -1)
const _hoisted_17 = [
  _hoisted_13,
  _hoisted_14,
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = { class: "change_list_btns" }
const _hoisted_19 = { class: "chk" }
const _hoisted_20 = ["value"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_22 = ["src"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "gal_thumb_img" }
const _hoisted_25 = ["src"]
const _hoisted_26 = { class: "gal_thumb_info_div" }
const _hoisted_27 = { class: "gal_info_list" }
const _hoisted_28 = { class: "gal_info_top" }
const _hoisted_29 = { class: "gal_info_tit" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("b", null, "순번", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "gal_info_tit" }, "고유번호", -1)
const _hoisted_32 = { class: "gal_info_con" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "gal_info_tit" }, "플랫폼", -1)
const _hoisted_34 = { class: "gal_info_con" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "gal_info_tit" }, "제목", -1)
const _hoisted_36 = { class: "gal_info_con" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "gal_info_tit" }, "카테고리", -1)
const _hoisted_38 = ["innerHTML"]
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "gal_info_tit" }, "등록일자", -1)
const _hoisted_40 = { class: "gal_info_con" }
const _hoisted_41 = { class: "gal_info_list" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "gal_info_tit" }, "판단여부", -1)
const _hoisted_43 = ["textContent"]
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "gal_info_tit" }, "판단근거", -1)
const _hoisted_45 = ["innerHTML"]
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", { class: "gal_info_tit" }, "탐지근거", -1)
const _hoisted_47 = ["innerHTML"]
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "gal_info_tit" }, "내용", -1)
const _hoisted_49 = ["innerHTML"]
const _hoisted_50 = { class: "gal_top_box" }
const _hoisted_51 = { class: "gal_top_left" }
const _hoisted_52 = { class: "chk" }
const _hoisted_53 = ["value"]
const _hoisted_54 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_55 = { class: "gal_thumb" }
const _hoisted_56 = { class: "gal_thumb_img" }
const _hoisted_57 = ["src", "onClick"]
const _hoisted_58 = { class: "gal_top_txt" }
const _hoisted_59 = { class: "gal_info_top_box" }
const _hoisted_60 = { class: "gal_info_top" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("b", null, "순번", -1)
const _hoisted_62 = { class: "gal_info_top" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("b", null, "고유번호", -1)
const _hoisted_64 = { class: "gal_info_div" }
const _hoisted_65 = { class: "gal_info_list" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("div", { class: "gal_info_tit" }, "플랫폼", -1)
const _hoisted_67 = ["innerHTML"]
const _hoisted_68 = /*#__PURE__*/_createElementVNode("div", { class: "gal_info_tit" }, "내용", -1)
const _hoisted_69 = ["innerHTML"]
const _hoisted_70 = /*#__PURE__*/_createElementVNode("div", { class: "gal_info_tit" }, "탐지근거", -1)
const _hoisted_71 = { class: "gal_info_con" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("div", { class: "gal_info_tit" }, "판단근거", -1)
const _hoisted_73 = { class: "gal_info_con" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("div", { class: "gal_info_tit" }, "카테고리", -1)
const _hoisted_75 = { class: "gal_info_con" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("div", { class: "gal_info_tit" }, "등록일자", -1)
const _hoisted_77 = { class: "gal_info_con" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Filter = _resolveComponent("Filter")!
  const _component_NoResult = _resolveComponent("NoResult")!
  const _component_PageBtn = _resolveComponent("PageBtn")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_Popup = _resolveComponent("Popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Header),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_Filter, {
                sns: false,
                resultType: false,
                resultDetailType: false,
                nation: false,
                isMonitoring: false,
                aiState: true,
                type: false,
                selectOption: $setup.state.selectOption,
                onSearch: $setup.filterSearch,
                onReset: $setup.resetSearch
              }, null, 8, ["selectOption", "onSearch", "onReset"]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "board_btn",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.checkAll()))
                  }, "전체선택"),
                  _createElementVNode("button", {
                    type: "button",
                    class: "board_btn board_ico_btn",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.excelDownLoad && $setup.excelDownLoad(...args)))
                  }, _hoisted_10)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, _toDisplayString($setup.numberFormat($setup.state.totalLength)) + "건", 1),
                  _withDirectives(_createElementVNode("select", {
                    name: "",
                    id: "",
                    class: "select",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.state.perPage) = $event))
                  }, _hoisted_17, 512), [
                    [
                      _vModelSelect,
                      $setup.state.perPage,
                      void 0,
                      { number: true }
                    ]
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("button", {
                      type: "button",
                      class: _normalizeClass(["list_btn", $setup.state.layer === 0 ? 'on' : '']),
                      onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.changeLayer(0)))
                    }, null, 2),
                    _createElementVNode("button", {
                      type: "button",
                      class: _normalizeClass(["gal_btn", $setup.state.layer === 1 ? 'on' : '']),
                      onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.changeLayer(1)))
                    }, null, 2)
                  ])
                ])
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["gal_list_wrap", $setup.state.layer === 1 ? 'card' : ''])
              }, [
                (!$setup.state.isLoading)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      ($setup.result.list.length !== 0)
                        ? (_openBlock(), _createElementBlock("ul", {
                            key: 0,
                            class: _normalizeClass($setup.state.layer === 0 ? 'gal_list' : 'gal_list_v2')
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.result.list, (item, idx) => {
                              return (_openBlock(), _createElementBlock("li", {
                                class: _normalizeClass(item.aiState === 1 ? 'detect' : '')
                              }, [
                                _createElementVNode("div", {
                                  class: _normalizeClass([$setup.state.layer === 0 ? 'gal_list_con' : 'gal_con', ,])
                                }, [
                                  ($setup.state.layer === 0)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createElementVNode("div", null, [
                                          _createElementVNode("label", _hoisted_19, [
                                            _withDirectives(_createElementVNode("input", {
                                              type: "checkbox",
                                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.state.checkList) = $event)),
                                              value: item.idx
                                            }, null, 8, _hoisted_20), [
                                              [_vModelCheckbox, $setup.state.checkList]
                                            ]),
                                            _hoisted_21
                                          ]),
                                          (item.aiState === 1)
                                            ? (_openBlock(), _createElementBlock("img", {
                                                key: 0,
                                                src: require('@/assets/common/report_wh.png'),
                                                style: {"background":"red","margin-top":"10px","width":"100%"}
                                              }, null, 8, _hoisted_22))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", {
                                          class: "gal_thumb",
                                          onClick: ($event: any) => ($setup.isDetailModal(item))
                                        }, [
                                          _createElementVNode("div", _hoisted_24, [
                                            _createElementVNode("img", {
                                              src: item.file ? item.file : require('@/assets/common/NoImg.png'),
                                              onError: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => ($setup.errorImg && $setup.errorImg(...args)))
                                            }, null, 40, _hoisted_25)
                                          ])
                                        ], 8, _hoisted_23),
                                        _createElementVNode("div", _hoisted_26, [
                                          _createElementVNode("ul", _hoisted_27, [
                                            _createElementVNode("li", _hoisted_28, [
                                              _createElementVNode("div", _hoisted_29, [
                                                _hoisted_30,
                                                _createElementVNode("span", null, _toDisplayString($setup.state.currentPage === 1
                                                                                ? idx + 1
                                                                                : $setup.state.perPage * ($setup.state.currentPage - 1) + idx + 1), 1)
                                              ])
                                            ]),
                                            _createElementVNode("li", null, [
                                              _hoisted_31,
                                              _createElementVNode("div", _hoisted_32, _toDisplayString(item.idx), 1)
                                            ]),
                                            _createElementVNode("li", null, [
                                              _hoisted_33,
                                              _createElementVNode("div", _hoisted_34, _toDisplayString(item.platform), 1)
                                            ]),
                                            _createElementVNode("li", null, [
                                              _hoisted_35,
                                              _createElementVNode("div", _hoisted_36, _toDisplayString(item.title), 1)
                                            ]),
                                            _createElementVNode("li", null, [
                                              _hoisted_37,
                                              _createElementVNode("div", {
                                                class: "gal_info_con",
                                                innerHTML: item.category
                                              }, null, 8, _hoisted_38)
                                            ]),
                                            _createElementVNode("li", null, [
                                              _hoisted_39,
                                              _createElementVNode("div", _hoisted_40, _toDisplayString($setup.formatDate(item.createDate)), 1)
                                            ])
                                          ]),
                                          _createElementVNode("ul", _hoisted_41, [
                                            _createElementVNode("li", null, [
                                              _hoisted_42,
                                              _createElementVNode("div", {
                                                class: "gal_info_con",
                                                textContent: _toDisplayString(item.aiState === 1 ? '판단됨' : '판단 안됨')
                                              }, null, 8, _hoisted_43)
                                            ]),
                                            _createElementVNode("li", null, [
                                              _hoisted_44,
                                              _createElementVNode("div", {
                                                class: "gal_info_con",
                                                innerHTML: item.judgmentReason
                                              }, null, 8, _hoisted_45)
                                            ]),
                                            _createElementVNode("li", null, [
                                              _hoisted_46,
                                              _createElementVNode("div", {
                                                class: "gal_info_con",
                                                innerHTML: item.detectionReason
                                              }, null, 8, _hoisted_47)
                                            ]),
                                            _createElementVNode("li", null, [
                                              _hoisted_48,
                                              _createElementVNode("div", {
                                                class: "gal_info_con",
                                                innerHTML: item.content
                                              }, null, 8, _hoisted_49)
                                            ])
                                          ])
                                        ])
                                      ], 64))
                                    : _createCommentVNode("", true),
                                  ($setup.state.layer === 1)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createElementVNode("div", _hoisted_50, [
                                          _createElementVNode("div", _hoisted_51, [
                                            _createElementVNode("label", _hoisted_52, [
                                              _withDirectives(_createElementVNode("input", {
                                                type: "checkbox",
                                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.state.checkList) = $event)),
                                                value: item.idx
                                              }, null, 8, _hoisted_53), [
                                                [_vModelCheckbox, $setup.state.checkList]
                                              ]),
                                              _hoisted_54
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_55, [
                                            _createElementVNode("div", _hoisted_56, [
                                              _createElementVNode("img", {
                                                src: item.file ? item.file : require('@/assets/common/NoImg.png'),
                                                onError: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => ($setup.errorImg && $setup.errorImg(...args))),
                                                onClick: ($event: any) => ($setup.isDetailModal(item))
                                              }, null, 40, _hoisted_57)
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_58, [
                                            _createElementVNode("div", null, [
                                              _createElementVNode("div", _hoisted_59, [
                                                _createElementVNode("p", _hoisted_60, [
                                                  _hoisted_61,
                                                  _createElementVNode("span", null, _toDisplayString($setup.state.currentPage === 1
                                                                                    ? idx + 1
                                                                                    : $setup.state.perPage * ($setup.state.currentPage - 1) + idx + 1), 1)
                                                ]),
                                                _createElementVNode("p", _hoisted_62, [
                                                  _hoisted_63,
                                                  _createElementVNode("span", null, _toDisplayString(item.idx), 1)
                                                ])
                                              ])
                                            ])
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_64, [
                                          _createElementVNode("ul", _hoisted_65, [
                                            _createElementVNode("li", null, [
                                              _hoisted_66,
                                              _createElementVNode("div", {
                                                class: "gal_info_con",
                                                innerHTML: item.platform
                                              }, null, 8, _hoisted_67)
                                            ]),
                                            _createElementVNode("li", null, [
                                              _hoisted_68,
                                              _createElementVNode("div", {
                                                class: "gal_info_con",
                                                innerHTML: item.content
                                              }, null, 8, _hoisted_69)
                                            ]),
                                            _createElementVNode("li", null, [
                                              _hoisted_70,
                                              _createElementVNode("div", _hoisted_71, _toDisplayString(item.detectionReason), 1)
                                            ]),
                                            _createElementVNode("li", null, [
                                              _hoisted_72,
                                              _createElementVNode("div", _hoisted_73, _toDisplayString(item.judgmentReason), 1)
                                            ]),
                                            _createElementVNode("li", null, [
                                              _hoisted_74,
                                              _createElementVNode("div", _hoisted_75, _toDisplayString(item.category), 1)
                                            ]),
                                            _createElementVNode("li", null, [
                                              _hoisted_76,
                                              _createElementVNode("div", _hoisted_77, _toDisplayString($setup.formatDate(item.createDate)), 1)
                                            ])
                                          ])
                                        ])
                                      ], 64))
                                    : _createCommentVNode("", true)
                                ], 2)
                              ], 2))
                            }), 256))
                          ], 2))
                        : (_openBlock(), _createBlock(_component_NoResult, {
                            key: 1,
                            class: "result_load"
                          })),
                      ($setup.result.list.length !== 0 && !$setup.state.isLoading)
                        ? (_openBlock(), _createBlock(_component_PageBtn, {
                            key: 2,
                            currentPage: $setup.state.currentPage,
                            totalLength: $setup.state.totalLength,
                            perPage: $setup.state.perPage,
                            onOnPaging: $setup.handlePageChange
                          }, null, 8, ["currentPage", "totalLength", "perPage", "onOnPaging"]))
                        : _createCommentVNode("", true)
                    ], 64))
                  : (_openBlock(), _createBlock(_component_Spinner, {
                      key: 1,
                      isLoading: $setup.state.isLoading,
                      class: "result_load"
                    }, null, 8, ["isLoading"]))
              ], 2)
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Popup, {
      show: $setup.state.isModalOpen,
      title: $setup.modal.title,
      content: $setup.modal.content,
      onClose: $setup.modalClose
    }, null, 8, ["show", "title", "content", "onClose"])
  ], 64))
}